import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-premiere-event-agenda',
  templateUrl: './premiere-event-agenda.component.html',
  styleUrls: ['./premiere-event-agenda.component.css']
})
export class PremiereEventAgendaComponent implements OnInit {
  @Input('premiereDetails') premiereDetails:any;
  
  @Input('eventid') eventid: any;   //for symposium
  @Input('id') eventId: any;        //for spotlight

  constructor() { }

  ngOnInit(): void {
  }

}
